export default __webpack_public_path__ + "static/media/dod-logo.4f6a3652.svg";